import { Component, ReactNode } from 'react';

import { Error500 } from '@/components/Error';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  error?: Error;
}

export default class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  state: ErrorBoundaryState = {};

  render() {
    const { children } = this.props;
    const { error } = this.state;

    if (error) {
      return <Error500 error={error} />;
    }
    return children;
  }
}
